import { useEffect, useState } from 'react';

/**
 * Tracks browser connectivity.
 *
 * Used to avoid rendering third-party embeds (the Google Maps iframe) when
 * there is no connection — an unreachable iframe renders as an empty grey box,
 * whereas a local fallback still communicates the address.
 *
 * navigator.onLine is only a hint: true means "has a network interface", not
 * "the internet is reachable". That is good enough here, since the fallback is
 * no worse than the broken embed it replaces.
 */
export const useOnline = () => {
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  return online;
};

export default useOnline;
